import React, { useEffect, useMemo, useRef, useReducer, useState } from 'react';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros'; 
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { Tooltip } from '../../components/utils/Tooltip';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { BotonExportarExcel } from '../../components/buttons/BotonExportarExcel';
import { BotonGeneral } from '../../components/buttons/BotonGeneral';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { SearchTable } from '../../components/utils/SearchTable';
import { useGestionNeumaticos } from '../GestionNeumaticos/useGestionNeumaticos';

import imagenVolante from '../../../assets/images/imagenVolante.webp'
import { DatePickerABX } from '../../components/pickers/DatePicker';
import { formatDate, notify } from '../../../utils/utils';
import { useBloqueoPantalla } from '../../../hooks/useBloqueoPantalla';
import { Select2 } from '../../components/forms/Select2';
import EnlazeDesenlazeNeumatico from '../../components/pages/Neumaticos/EnlazeDesenlazeNeumatico';


export const MovimientosNeumaticos = () => {
    const [isOpen, openModal, closeModal] = useModal()
    const [isOpenDetallado, openModalDetallado, closeModalDetallado] = useModal()
    const [bloquearPantalla,desbloquearPantalla,ComponenteBloqueo] = useBloqueoPantalla()

    const ejePosicionDefault = {
        eje: 0,
        posicion: 0,
        codUnidadNeumatico: 0
    }
    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white"   
    
    const [ordenTrabajo,setOrdenTrabajo] = useState(0)
    const [ejePosicionSelecccionada,setEjePosicionSeleccionada] = useState(ejePosicionDefault)
    const [textoAnulacion,setTextoAnulacion] = useState('')
    const [fechaRegistroModal,setFechaRegistroModal] = useState(new Date())

    const {
        listadoMovimientoNeumaticos,
        movimientos,
        listadoDetalladoMovimiento,
        detalladoMovimiento,

        listarComboOrdenTrabajo,
        ordenesTrabajo,

        listarCabeceraDetalleNeumatico,
        cabeceraDetalleNeumatico,

        listarNeumaticosSinEnlaze,
        neumaticosSinEnlaze,
        
        consultaNeumaticoEnlazado,
        neumaticoEnlazado,

        listarNeumaticoEstado,
        estadosNeumaticos,


        infoNeumatico,
        setInfoNeumatico,
        infoNeumaticoDefault,
        editarInfoNeumatico,



        editarNeumatico,
        enlazarNeumaticoUnidad,
        desenlazarNeumaticoUnidad
    } = useGestionNeumaticos()

    useEffect(() => {
        const funcionReady = async () => {
            bloquearPantalla()
            await listadoMovimientoNeumaticos()
            await listarComboOrdenTrabajo()
            await listarNeumaticosSinEnlaze()
            await listarNeumaticoEstado()
            desbloquearPantalla()
        }

        funcionReady()
    }, [])

    useEffect(() => {
        if(Object.keys(neumaticoEnlazado).length != 0){
            setInfoNeumatico(Object.assign({},infoNeumaticoDefault,neumaticoEnlazado))
        }
    },[neumaticoEnlazado])

    return (
        <>
            <ComponenteBloqueo></ComponenteBloqueo>
            <ContenedorParametros
                titulo='Movimiento de neumático' tablaId="tablaId"
            >   
                <BotonProcesar onClick={listadoMovimientoNeumaticos}></BotonProcesar>       
                
                <BotonNuevo 
                    onClick={() => {
                        openModal()
                        setFechaRegistroModal(new Date())
                        setOrdenTrabajo(0)
                        setEjePosicionSeleccionada(ejePosicionDefault)
                        listarNeumaticosSinEnlaze()
                        listarCabeceraDetalleNeumatico(0)
                        setInfoNeumatico(infoNeumaticoDefault)
                    }}
                ></BotonNuevo>
                
            </ContenedorParametros>
            
            <Tooltip id={'Estado'}>Estado</Tooltip>
            <Tooltip id={'Categoria'}>Categoria</Tooltip>

            <div className="containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
                <table id="tablaId" className="tableResponsive">
                    <thead>
                        <tr>
                            <th className="w-[20px] whitespace-nowrap text-center">N°</th>
                            <th className="w-[200px] whitespace-nowrap">UNIDAD</th>
                            <th className="w-[80px] whitespace-nowrap">N° EJE</th>
                            <th className="w-[80px] whitespace-nowrap">N° POS</th>
                            <th className="whitespace-nowrap">COD.NEUMATICO</th>
                            <th className="whitespace-nowrap">F.ACTUALIZACIÓN</th>
                            <th className="whitespace-nowrap">U.ACTUALIZACIÓN</th>
                            <th className="w-[80px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                    {   
                                movimientos.length > 0 
                                ? Object.values(Object.groupBy(movimientos,e => e.codUnidad)).map((data0, i) => {
                                    return data0.map((data,j) => {
                                        return (
                                            <tr 
                                                key={`${i}_${j}`}
                                                onClick={() => {
                                                    listadoDetalladoMovimiento(data.codUnidad,data.nroEje,data.nroPosicion)
                                                    openModalDetallado()
                                                }} 
                                            >
                                                {j == 0 ? <td rowSpan={data0.length} data-label="" className=' w-[20px]'>{i+1}</td> : ''}
                                                {j == 0 ? <td rowSpan={data0.length} data-label="Nombre" className=" w-[20px] whitespace-nowrap">{data.unidad}</td> : ''}
                                                <td data-label="Marca" className="">{data.nroEje}</td>
                                                <td data-label="Codigo" className="">{data.nroPosicion}</td>
                                                <td data-label="U. Medida" className="">{data.codigoNeumatico}</td>
                                                <td data-label="P. Compra" className=" whitespace-nowrap">{data.fechaActualizacion}</td>
                                                <td data-label="Caracteristicas" className="">{data.nomUsuario || '-'}</td>
                                                <td data-label="Opciones" className="tableopciones w-[50px]" >
                                                    <button onClick={() => {
                                                            listadoDetalladoMovimiento(data.codUnidad,data.nroEje,data.nroPosicion)
                                                            openModalDetallado()
                                                        }}  className="bg-blue-500 hover:bg-blue-600 text-[14px] px-[5px] py-1 rounded">
                                                        <i className="fas fa-search"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }).flat()
                                : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                            }
                                
                    </tbody> 
                </table>
            </div>

            {/* MODAL PARA EL ENLAZE Y DESENLAZE DE LOS NEUMATICOS */}
            <Modal 
                isOpen={isOpen} 
                closeModal={closeModal} 
                validButton={{}}
                action={{}}
                title="Registro de neumáticos por unidad"
                spinner={{}}
            >
                <div className='w-[800px] lg:w-full'>
                    <EnlazeDesenlazeNeumatico
                        closeModalContenedor={() => {closeModal();listadoMovimientoNeumaticos()}}
                    />
                </div>
            </Modal>

            <Modal
                title={'Detalle movimiento de neumático'}
                isOpen={isOpenDetallado}
                closeModal={closeModalDetallado}
                textButtons={{denied:'Cerrar'}}
                validButton={{denied:true}}
            >
                <div className='p-4'>
                    <div className='relative inset-0 max-h-[400px] overflow-auto containerScroll'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>Nº</th>
                                    <th>Nº EJE</th>
                                    <th>Nº POSICION</th>
                                    <th>C.NEUMÁTICO</th>
                                    <th>U.ENLACE</th>
                                    <th>U.DESCENLACE</th>
                                    <th>F.ENLACE</th>
                                    <th>F.DESENLACE</th>
                                    <th>ESTADO</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    detalladoMovimiento.length != 0 ?
                                        detalladoMovimiento.map((data,i) => {
                                            return(
                                                <tr key={i+1}>
                                                    <td className='text-center font-bold'>{i+1}</td>
                                                    <td className='text-center'>{data.nroEje || '-'}</td>
                                                    <td className='text-center'>{data.nroPosicion || '-'}</td>
                                                    <td className='text-center'>{data.codigoNeumatico || '-'}</td>
                                                    <td className='text-center'>{data.nomUsuarioEnlace || '-'}</td>
                                                    <td className='text-center'>{data.nomUsuarioDesenlace || '-'}</td>
                                                    <td className='text-center'>{data.fechaEnlace || '-'}</td>
                                                    <td className='text-center'>{data.fechaDesenlace || '-'}</td>
                                                    <td className='text-center'>{data.estado || '-'}</td>
                                                </tr>
                                            )
                                        })
                                    :
                                        <tr><td className='text-center' colSpan={9}>No hay información para mostrar...</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </>
    )
}